import { Card, Col, Input, Space } from "antd";
import Table, { TableProps } from "antd/lib/table";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import NotSet from "../../components/NotSet";
import { formatDate } from "../../helpers/format";
import useFetchList from "../../hooks/useFetchList";
import { ListingProperties } from "../../types/listing.type";
import { PortalListingProperties } from "../../types/portalListing.type";
import PortalSyncResult from "./components/PortalSyncResult";
import HeaderSection from "../../components/HeaderSection";
import Filter from "../../components/Filter";
import FilterOffice from "../../components/form/FilterOffice";
import { SearchOutlined } from "@ant-design/icons";

const ListingHasPortal: React.FC = () => {
	const { isLoading, data, pagination, changePage, setSearch, setQuery, search, query } = useFetchList<
		ListingProperties,
		any
	>({
		endpoint: "listings/has-portal",
	});
	const location = useLocation();

	const queryParams = new URLSearchParams(location.search);
	const filterEmployeeId = queryParams.get("filterEmployeeId");
	const filterPortalId = queryParams.get("filterPortalId");

	useEffect(() => {
		if (filterEmployeeId) {
			setQuery({
				...query,
				filterEmployeeId,
				filterPortalId,
			});
		}
	}, [filterEmployeeId, filterPortalId]);

	const COLUMNS: TableProps<ListingProperties>["columns"] = [
		{
			title: "LISTING ID",
			key: "listingCode",
			dataIndex: "listingCode",
			width: 120,
			render: (listingCode: string, record: ListingProperties) => {
				return (
					<Link to={"/listing/" + record.listingId}>
						{listingCode ? listingCode?.toUpperCase() : <NotSet />}
					</Link>
				);
			},
		},
		{
			title: "TITLE",
			key: "title",
			dataIndex: "title",
			width: 200,
			render(value: string) {
				return value ?? <NotSet />;
			},
		},
		{
			title: "OFFICE",
			dataIndex: ["office", "officeName"],
			key: "officeName",
			width: 150,
		},
		{
			title: "AGENT NAME",
			dataIndex: ["user", "nickName"],
			key: "nickName",
			width: 200,
			render: (nickName: string) => <>{nickName ? nickName?.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "LIST PORTAL",
			dataIndex: "portalListing",
			key: "portalListing",
			width: 200,
			render: (portLists: PortalListingProperties[], record: ListingProperties) => {
				return (
					<PortalSyncResult
						portLists={portLists}
						listing={record}
					/>
				);
			},
		},
		{
			title: "POSTING DATE",
			dataIndex: "publishAt",
			key: "publishAt",
			width: 150,
			render: formatDate,
		},
	].filter(Boolean) as TableProps<ListingProperties>["columns"];

	const _handleFilterOffice = (value: string) => {
		setQuery({
			...query,
			offset: 0,
			filterOfficeId: value,
		});
	};

	return (
		<React.Fragment>
			<Space
				direction="vertical"
				size="large"
			>
				<HeaderSection title="Data Listing Has Portal">
					<Filter maxWidth={"100%"}>
						<Col
							xs={{ span: 12 }}
							md={{ span: 12 }}
						>
							<Input
								className="outer-shadow"
								placeholder="Search by Title"
								suffix={<SearchOutlined />}
								allowClear
								onChange={(e) => setSearch(e.target.value)}
								value={search}
							/>
						</Col>

						<Col
							xs={{ span: 12 }}
							md={{ span: 6 }}
						>
							<FilterOffice
								value={query.filterOfficeId}
								onChange={_handleFilterOffice}
							/>
						</Col>
					</Filter>
				</HeaderSection>
				<Card
					bordered={false}
					size="small"
				>
					<Table
						loading={isLoading}
						columns={COLUMNS}
						dataSource={data}
						rowKey="listingId"
						pagination={false}
						scroll={{ x: "100%" }}
					/>
					<CustomPagination
						current={pagination.page}
						total={pagination.totalData}
						defaultPageSize={pagination.perPage}
						pageSize={pagination.perPage}
						onChange={changePage}
					/>
				</Card>
			</Space>
		</React.Fragment>
	);
};
export default ListingHasPortal;
